module.exports = __webpack_public_path__ + "img/internal_medicine.51dea780.svg";